
import { defineComponent } from 'vue'
import DoctorWorkflow from './DoctorWorkflow.vue'
import NurseWorkflow from './NurseWorkflow.vue'
import PatientSummary from '../shared/PatientSummary.vue'
import { store } from '../shared/store.js'

export default defineComponent({
  name: 'PatientDetail',
  components: {
    NurseWorkflow,
    DoctorWorkflow,
    PatientSummary
  },
  data () {
    return {
      store,
      encounterTypeItems: ['Inpatient', 'Outpatient', 'Day Surgery', 'Emergency'],
      visitTypeItems: ['Admission', 'Procedure', 'Consultation'],
      movementTypeItems: ['Fist Visit', 'Repeat Visit', 'Admission', 'Readmission'],
      locationItems: ['Ward 12', 'Eye Clinic', 'Procedure 123'],
      patientClassItems: ['Private', 'Subsidised'],
      accomodationItems: ['1 Bedder', '2 Bedder', '4 Bedder', '6 Bedder', 'Other'],
      patientSummary: {
        name: 'Strawberry Shortcake Jamz',
        birthdate: '01 Jan 1980',
        age: '20',
        location: 'Ward 12 Bed 3',
        currentLocation: 'Procedure 123',
        hrn: 332211,
        visitNumber: "VHI-230508"
      },
      admissionDate: new Date().toISOString().substr(0, 10),
    }
  }
})
